"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var decorator_exports = {};
__export(decorator_exports, {
  Retryable: () => Retryable
});
module.exports = __toCommonJS(decorator_exports);
var import_retry = require("./retry");
function Retryable(options = import_retry.DEFAULT_RETRY_OPTIONS) {
  return function(target, propertyKey, descriptor) {
    const originalMethod = descriptor.value;
    descriptor.value = async function(...args) {
      const methodName = propertyKey.toString();
      return await (0, import_retry.withRetry)(() => originalMethod.apply(this, args), options, methodName);
    };
    return descriptor;
  };
}
__name(Retryable, "Retryable");
//# sourceMappingURL=decorator.js.map
